// src/components/PhotoGallery.jsx
import React, { useState } from "react";
import styles from "./PhotoGallery.module.css";

function PhotoGallery({ photos, currentFolder }) {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const handlePhotoClick = (photo) => {
    setSelectedPhoto(photo);
    document.body.style.overflow = "hidden"; // Prevents scrolling on the body
  };

  const handleCloseModal = () => {
    setSelectedPhoto(null);
    document.body.style.overflow = "unset"; // Re-enables scrolling on the body
  };

  if (!photos || photos.length === 0) {
    return <p>No photos found in this folder.</p>;
  }

  return (
    <>
      <div className={styles.photoGrid}>
        {photos.map((photo) => (
          <div
            key={photo.id}
            className={styles.photoCard}
            onClick={() => handlePhotoClick(photo)}
          >
            <img src={photo.url} alt={photo.caption} loading="lazy" />
          </div>
        ))}
      </div>

      {selectedPhoto && (
        <div className={styles.modalOverlay} onClick={handleCloseModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={styles.closeButton} onClick={handleCloseModal}>
              &times;
            </button>

            <div className={styles.modalScrollable}>
              <img
                src={selectedPhoto.url}
                alt={selectedPhoto.caption}
                className={styles.modalImage}
              />
              <div className={styles.modalDetails}>
                <p className={styles.modalCaption}>{selectedPhoto.caption}</p>
                <div className={styles.modalTags}>
                  {selectedPhoto.tags.map((tag) => (
                    <span key={tag} className={styles.tag}>
                      {tag}
                    </span>
                  ))}
                </div>
                {/* Download Button moved here, inside modalDetails */}
                <a
                  href={selectedPhoto.url}
                  download={selectedPhoto.caption || "family-photo"}
                  className={styles.downloadButton}
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PhotoGallery;
